<div class="divider"></div>
<div class="divider__dummy"></div>
